import { useTranslation } from 'next-i18next';
import React, { ForwardRefRenderFunction } from 'react';

import { NS } from '@/constants';
import { Rating } from '@/types';

import TabContainer from '@/components/common/Tab/TabContainer';
import CarouselWineCritics from '@/components/product/CarouselWineCritics';
import RPCritic from '@/components/product/RPCritic';

import styles from './ProductNotation.module.scss';

type ProductNotationProps = {
  ratings: Rating[];
  parkerTastingNote?: string;
}

const InnerComponent : ForwardRefRenderFunction<HTMLDivElement, ProductNotationProps> = (
  ({ ratings, parkerTastingNote }, ref) => {
    const { t } = useTranslation(NS.COMMON);

    const carouselComponent = <CarouselWineCritics ratings={ratings} />;
    const rpCriticComponent = <RPCritic parkerTastingNote={parkerTastingNote} />;

    const tabsProps = [
      {
        id: 'ratings',
        label: t('product.rating'),
        disabled: ratings.length === 0,
        content: carouselComponent
      },
      {
        id: 'parkerTastingNote',
        label: t('product.parkerTastingNote'),
        disabled: !parkerTastingNote,
        content: rpCriticComponent
      }
    ];

    return (
      <div ref={ref}>
        <p className={styles.title} data-test-id="title">{t('product.notation')}</p>

        <TabContainer tabs={tabsProps} defaultTabId={ratings.length > 0 ? 'ratings' : 'parkerTastingNote'} />
      </div>
    );
  }
);

InnerComponent.displayName = 'ProductNotation';

const ProductNotation = React.forwardRef(InnerComponent);
export default ProductNotation;
